import React from "react/lib/React";
import { PropTypes } from "react";
import ConfigurationForm from "./ConfigurationForm";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as clientActions from "../clientActions";

class ConfigurationPage extends React.Component {
  constructor(props) {
    super(props);
    this._handleTabChange = this._handleTabChange.bind(this);
  }

  _handleTabChange() {
    /** Dispatches the shared thunk to refresh client status type and patch Redux + localStorage. */
    const clientId = this.props.client && this.props.client.clientId;
    if (!clientId) return;
    this.props.clientActions.refreshClientStatusType(clientId);
  }

  render() {
    return (
      <div className="sub-content">
        <ConfigurationForm onTabChange={this._handleTabChange} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const clients = state.data.clients || {};
  return {
    client: clients.active,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    clientActions: bindActionCreators(clientActions, dispatch),
  };
}

ConfigurationPage.propTypes = {
  client: PropTypes.object,
  clientActions: PropTypes.object,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurationPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/configuration/ConfigurationPage.js